const formateUserName = (str) => {
    return str;
}
export default formateUserName;